module.exports = __webpack_public_path__ + "img/114.3.c0dc0a2b.png";